export const json = {
    "pages": [
      {
        "name": "page1",
        "elements": [
          {
            "type": "text",
            "name": "full_name",
            "title": "What is your Full Name?",
            "isRequired": true
          },
          {
            "type": "text",
            "name": "company_name",
            "title": "What is your Company Name?",
            "isRequired": true
          },
          {
            "type": "text",
            "name": "mobile_number",
            "title": "Please provide your Mobile Number?",
            "isRequired": true,
            "validators": [
              {
                "type": "regex",
                "regex": "^[6-9]\\d{9}$",
                "text": "Please enter a valid mobile number starting with 6, and containing 10 digits."
              }
            ]
          },
          {
            "type": "text",
            "name": "email",
            "title": "What is your Email ID?",
            "isRequired": true,
            "validators": [
              {
                "type": "email",
                "text": "Please enter a valid email address."
              }
            ]
          },
          {
            "type": "radiogroup",
            "name": "it_challenges",
            "title": "Are you currently facing any specific IT challenges or pain points?",
            "choices": [
              "Yes",
              "Not"
            ],
            "isRequired": true
          },
          {
            "type": "radiogroup",
            "name": "benefit_areas",
            "title": "What areas of your company's operations could benefit from improved technology solutions?",
            "choices": [
              "Data Management and Analytics",
              "Cloud Computing and Infrastructure",
              "Cybersecurity and Compliance",
              "Custom Software Development",
              "Process Automation",
              "Not Sure"
            ],
            "isRequired": true
          },
          {
            "type": "radiogroup",
            "name": "customized_solutions_interest",
            "title": "Would you be interested in discussing customized solutions tailored to your company's unique needs?",
            "choices": [
              "Yes",
              "No"
            ],
            "isRequired": true
          },
          {
            "type": "checkbox",
            "name": "interested_products_services",
            "title": "Which of the following products or services are you interested in? (Select all that apply)",
            "choices": [
              "Software Applications",
              "IT Consulting and Strategy",
              "Managed Services",
              "Enterprise Integration Solutions",
              "Digital Transformation Services",
              "Other"
            ],
            "isRequired": true
          },
          {
            "type": "radiogroup",
            "name": "budget_range",
            "title": "What is your estimated budget range for IT solutions or services? (Options in INR)",
            "choices": [
              "0 to 2 Lakh",
              "2 to 5 Lakh",
              "5 to 10 Lakh",
              "10 to 50 Lakh",
              "Greater than 50 Lakh",
              "Depends"
            ],
            "isRequired": true
          },
          {
            "type": "checkbox",
            "name": "key_stakeholders",
            "title": "Who are the key stakeholders involved in IT-related decisions within your company?",
            "choices": [
              "Engineering Lead",
              "Project Manager",
              "Software Developer",
              "Designer",
              "Product Manager",
              "CEO / Founder",
              "Customer Support",
              "Other"
            ],
            "isRequired": true
          },
          {
            "type": "radiogroup",
            "name": "decision_timeline",
            "title": "When do you anticipate making a decision about implementing new IT solutions?",
            "choices": [
              "Within the next 3 months",
              "3 - 6 months",
              "6 - 12 months",
              "More than 12 months"
            ],
            "isRequired": true
          },
          {
            "type": "comment",
            "name": "additional_comments",
            "title": "Additional Comments (Optional)"
          }
        ]
      }
    ]
  };
  